module.exports = __webpack_public_path__ + "eadbef663bc9ec4f534897d02006a020.pdf";